// extracted by mini-css-extract-plugin
export default {"container":"loader_container__GFNbE","loader":"loader_loader__KB+N4","animate":"loader_animate__mJ2vJ"};